module.exports = __webpack_public_path__ + "img/slider-4.4550eb44.png";